import { cleanNotifications, showNotification } from "@mantine/notifications";
import axios from "axios";
import { backendUrl, dealershipID } from "./Constants";
import { Token } from "./UserDetails";
export const axiosGet = async ({ url, params, headers, withSNo }) => {
  let response;
  const token = Token();
  try {
    response = await axios.get(backendUrl + url, {
      ...params,
      headers: {
        Authorization: `Bearer ${token}`,
        Dealership: dealershipID,
        ...headers,
      },
    });
  } catch (err) {
    console.log("err", err);
    if (err.response?.status === 403 || err.response?.status === 401) {
      //session expiry
      cleanNotifications();
      showNotification({
        title: "Error",
        message: "Session Expired, Please Login Again",
        color: "red",
      });

      // TODO : redirect to login page and clear local storage but not via window.location.href
      // TODO : use something like history or navigate from react router dom
      window.location.href = "/signIn";
      //clear local storage
      localStorage.clear();
    } else if (err.response?.status === 400) {
      throw err;
    } else if (err.response?.status === 500) {
      throw new Error("Something went wrong");
    } else {
      cleanNotifications();
      showNotification({
        title: "Error",
        message: "Something went wrong",
        color: "red",
      });
    }
  }
  if (response?.data && withSNo) {
    response.data.data = response.data.data?.map((item, index) => {
      return { ...item, sNo: index + 1 };
    });
  }
  return response;
};

export const axiosPost = async ({ url, data, params, headers }) => {
  let response;
  let token = Token();
  try {
    response = await axios.post(backendUrl + url, data, {
      ...params,
      // form data
      headers: {
        Authorization: `Bearer ${token}`,
        dealership: dealershipID,
        ...headers,
      },
    });
    return response;
  } catch (err) {
    return err.response;
  }
};

export const axiosPut = async ({ url, data, params, headers }) => {
  const token = Token();
  const response = await axios.put(backendUrl + url, data, {
    ...params,
    headers: {
      Authorization: `Bearer ${token}`,
      dealership: dealershipID,
      ...headers,
    },
  });
  return response;
};

export const axiosPatch = async ({ url, data, params, headers }) => {
  const token = Token();
  const response = await axios.patch(backendUrl + url, data, {
    ...params,
    headers: {
      Authorization: `Bearer ${token}`,
      dealership: dealershipID,
      ...headers,
    },
  });
  return response;
};

export const axiosDelete = async ({ url, data }) => {
  const token = Token();
  const response = await axios.delete(backendUrl + url, {
    headers: {
      Authorization: `Bearer ${token}`,
      dealership: dealershipID,
    },
  });
  return response;
};
export const axiosSwitch = async (option, data) => {
  console.log("option", option, data);
  switch (option) {
    case "post":
      return axiosPost(data);
    case "patch":
      return axiosPatch(data);
    case "get":
    default:
      axiosGet(data);
  }
};
